import { SegmentedTabOption } from 'src/app/micro-components/segmented-tabs/segmented-tabs.component';
import { TogglePillOption } from 'src/app/micro-components/toggle-pill-group/toggle-pill-group.component';
import { DEFAULT_LANGUAGES } from 'src/app/shared/utils/language.constants';

/** Sentinel `time` value for a custom `from--to` range. */
export const CUSTOM_TIMEFRAME = '0';

/**
 * The persistent nav-bar timeframe segments. Values are the `time` query param.
 * The legacy "Today" option (`time=1`) is intentionally absent: it is no longer
 * selectable, but an inbound `time=1` still resolves and renders as no active
 * segment rather than being rewritten.
 */
export const TIMEFRAME_SEGMENTS: SegmentedTabOption<string>[] = [
  { value: '2', label: '24h', pendoClass: 'pendo-timeframe-option-24h' },
  { value: '7', label: '1W', pendoClass: 'pendo-timeframe-option-7d' },
  { value: '30', label: '1M', pendoClass: 'pendo-timeframe-option-30d' },
  { value: '90', label: '3M', pendoClass: 'pendo-timeframe-option-90d' },
  { value: '180', label: '6M', pendoClass: 'pendo-timeframe-option-180d' },
  { value: '365', label: 'Year', pendoClass: 'pendo-timeframe-option-365d' },
  {
    value: CUSTOM_TIMEFRAME,
    label: 'Custom range',
    icon: 'date_range',
    tooltip: 'Custom range',
    // The pop-up's Custom option carried the un-suffixed class; kept so existing
    // Pendo guides keep matching.
    pendoClass: 'pendo-timeframe-option',
  },
];

/** Chart smoothing window per timeframe. Custom ranges derive it from the span. */
export const TIMEFRAME_PERIOD_MAP: Record<string, { period: string }> = {
  '2': { period: '7' },
  '7': { period: '7' },
  '30': { period: '7' },
  '90': { period: '14' },
  '180': { period: '14' },
  '365': { period: '14' },
};

/** `time` assumed when the URL carries none — one week, matching the old menu. */
export const DEFAULT_TIMEFRAME = '7';

/** `period` assumed when a timeframe has no mapping (e.g. a custom range). */
export const DEFAULT_PERIOD = '7';

// Deliberately not `pendo-language-option` — that one belongs to the pop-up's
// Language column, and reusing it here would merge two different interactions.
export const LANGUAGE_TOGGLES: TogglePillOption<string>[] =
  DEFAULT_LANGUAGES.map((lang) => ({
    value: lang,
    label: lang.toUpperCase(),
    pendoClass: `pendo-nav-language-${lang}`,
  }));
